//message参数配置
import { Message } from "element-ui";

const messageSet = (msg, type) => {
    Message({ showClose: true, message: msg, type: type,offset: 20});
}
//成功
const success = (message) => {
    messageSet(message,'success');
}
//消息
const info = (message) => {
    messageSet(message,'info');
}
//错误
const error = (message) => {
    messageSet(message,'error');
}
//警告
const warning = (message) => {
    messageSet(message,'warning');
}

export default {
    success(message){
        success(message);
    },
    info(message){
        info(message);
    },
    error(message){
        error(message);
    },
    warning(message){
        warning(message);
    },
}
